export default {
  "pages.layouts.userLayout.title":
    "Hệ thống quản lý mã vạch chuyên nghiệp cho nền tảng Eatsy",
  "pages.login.accountLogin.tab": "Đăng nhập bằng tài khoản",
  "pages.login.accountLogin.errorMessage":
    "Sai tên đăng nhập/mật khẩu (admin/ant.design)",
  "pages.login.failure": "Đăng nhập thất bại, vui lòng thử lại!",
  "pages.login.success": "Đăng nhập thành công!",
  "pages.login.username.placeholder": "Tên đăng nhập: admin hoặc user",
  "pages.login.username.required": "Vui lòng nhập tên đăng nhập!",
  "pages.login.password.placeholder": "Mật khẩu: ant.design",
  "pages.login.password.required": "Vui lòng nhập mật khẩu!",
  "pages.login.phoneLogin.tab": "Đăng nhập bằng điện thoại",
  "pages.login.phoneLogin.errorMessage": "Lỗi mã xác thực",
  "pages.login.phoneNumber.placeholder": "Số điện thoại",
  "pages.login.phoneNumber.required": "Vui lòng nhập số điện thoại!",
  "pages.login.phoneNumber.invalid": "Số điện thoại không hợp lệ!",
  "pages.login.captcha.placeholder": "Mã xác thực",
  "pages.login.captcha.required": "Vui lòng nhập mã xác thực!",
  "pages.login.phoneLogin.getVerificationCode": "Lấy mã",
  "pages.getCaptchaSecondText": "giây",
  "pages.login.rememberMe": "Ghi nhớ đăng nhập",
  "pages.login.forgotPassword": "Quên mật khẩu?",
  "pages.login.submit": "Đăng nhập",
  "pages.login.loginWith": "Đăng nhập bằng:",
  "pages.login.registerAccount": "Đăng ký tài khoản",
  "pages.welcome.link": "Chào mừng",
  "pages.welcome.alertMessage":
    "Các component nặng nhanh hơn và mạnh mẽ hơn đã được phát hành.",
  "pages.404.subTitle": "Xin lỗi, trang bạn truy cập không tồn tại.",
  "pages.404.buttonText": "Về trang chủ",
  "pages.admin.subPage.title": "Trang này chỉ có thể được xem bởi Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui hiện đã được phát hành, chào mừng sử dụng npm run ui để bắt đầu trải nghiệm.",
  "pages.searchTable.createForm.newRule": "Quy tắc mới",
  "pages.searchTable.updateForm.ruleConfig": "Cấu hình quy tắc",
  "pages.searchTable.updateForm.basicConfig": "Thông tin cơ bản",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Tên quy tắc",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Vui lòng nhập tên quy tắc!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Mô tả quy tắc",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Vui lòng nhập ít nhất năm ký tự",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Vui lòng nhập mô tả quy tắc ít nhất năm ký tự!",
  "pages.searchTable.updateForm.ruleProps.title": "Cấu hình thuộc tính",
  "pages.searchTable.updateForm.object": "Đối tượng giám sát",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Mẫu quy tắc",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Loại quy tắc",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Thiết lập chu kỳ lập lịch",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel":
    "Thời gian bắt đầu",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Vui lòng chọn thời gian bắt đầu!",
  "pages.searchTable.titleDesc": "Mô tả",
  "pages.searchTable.ruleName": "Tên quy tắc là bắt buộc",
  "pages.searchTable.titleCallNo": "Số lần gọi dịch vụ",
  "pages.searchTable.titleStatus": "Trạng thái",
  "pages.searchTable.nameStatus.default": "mặc định",
  "pages.searchTable.nameStatus.running": "đang chạy",
  "pages.searchTable.nameStatus.online": "trực tuyến",
  "pages.searchTable.nameStatus.abnormal": "bất thường",
  "pages.searchTable.titleUpdatedAt": "Lần lập lịch cuối",
  "pages.searchTable.exception": "Vui lòng nhập lý do ngoại lệ!",
  "pages.searchTable.titleOption": "Tùy chọn",
  "pages.searchTable.config": "Cấu hình",
  "pages.searchTable.subscribeAlert": "Đăng ký cảnh báo",
  "pages.searchTable.title": "Biểu mẫu truy vấn",
  "pages.searchTable.new": "Mới",
  "pages.searchTable.chosen": "đã chọn",
  "pages.searchTable.item": "mục",
  "pages.searchTable.totalServiceCalls": "Tổng số lần gọi dịch vụ",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "xóa hàng loạt",
  "pages.searchTable.batchApproval": "phê duyệt hàng loạt",
};
